import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Messages } from './messages/messages';



@NgModule({
  declarations: [
    Messages
  ],
  imports: [
    CommonModule
  ],
  exports: [
    Messages,
  ]
})
export class MessagesModule { }
